import { anyOf, enumOf, maybe, objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

import SHARED_CONSTANTS from "@lib/shared_constants";

export const isGetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailResult = objectOf({
  body: anyOf(string, nullValidation),
  reason: maybe(enumOf(...Object.values(SHARED_CONSTANTS.PREVIEW_THUMBNAIL_FAILURE_REASONS))),
});
